import { ApiError, createApiClient } from '@ly360/ui';
import type { CalendarPref, DateStyle, DigitPref, TimeFormat } from '@ly360/i18n';

export { ApiError };

export interface UserPreferences {
  locale: string;
  timezone: string | null;
  timeFormat: TimeFormat | null;
  dateStyle: DateStyle | null;
  calendar: CalendarPref | null;
  numerals: DigitPref | null;
}

export interface TenantDefaults {
  locale: string;
  timezone: string;
  timeFormat: TimeFormat;
  dateStyle: DateStyle;
  calendar: CalendarPref;
  numerals: DigitPref;
  weekStart: number;
}

export interface Tenant {
  id: string;
  slug: string;
  name: string;
  nameAr: string | null;
  country: string;
  currency: string;
  residencyRegion: string;
  cellId: string;
  status: string;
  industryPack: string | null;
  defaults: TenantDefaults;
}

export interface Session {
  status: 'signed_in';
  accessToken: string;
  expiresIn: number;
  user: {
    id: string;
    email: string;
    displayName: string;
    displayNameAr: string | null;
    roles: string[];
    perms: string[];
    preferences: UserPreferences;
  };
  tenant: Tenant;
}

export interface TenantChoice {
  status: 'select_tenant';
  tenants: { slug: string; name: string; nameAr: string | null }[];
}

const client = createApiClient<Session>({
  base: '/api',
  refreshPath: '/v1/auth/refresh',
  noRetry: ['/v1/auth/login', '/v1/auth/refresh'],
  tokenOf: (s) => s.accessToken,
});

export const api = client.api;
export const download = client.download;
export const upload = client.upload;
export const apiBlob = client.blob;
export const refreshSession = client.refresh;
export const setAccessToken = client.setToken;
export const bindSession = client.onSession;
